import React from 'react';
import { useLoaderData, Link } from 'react-router-dom';
import { getFavoriteContractors } from '../api/userFavoriteContractor';
import { UserFavoriteContractor } from '../types/user';
import FavoriteButton from '../components/FavoriteButton';

// Loader function for React Router
export async function userFavoriteContractorsLoader() {
  const favoriteContractors = await getFavoriteContractors();
  return { favoriteContractors };
}

const UserFavoriteContractorsPage: React.FC = () => {
  const { favoriteContractors } = useLoaderData() as { favoriteContractors: UserFavoriteContractor[] };

  const handleToggleFavorite = (contractorId: number, isFavorited: boolean) => {
    // This callback can be used to update local state or re-fetch data if needed
    console.log(`Contractor ${contractorId} favorite status toggled to ${isFavorited}`);
    // For this page, we might want to re-fetch the data to remove the unfavorited item
    // or update the state directly. For simplicity, we'll just log for now.
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">My Favorite Contractors</h1>

      {favoriteContractors.length === 0 ? (
        <p className="text-center text-gray-500">You have no favorite contractors yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {favoriteContractors.map((favContractor) => (
            <div key={favContractor.id} className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition-shadow duration-200 flex flex-col">
              <Link to={`/contractors/${favContractor.contractorProfileId}`} className="block flex-grow">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">{favContractor.companyName}</h2>
                <p className="text-gray-600 mb-1">
                  <span className="font-medium">Email:</span> {favContractor.contactEmail}
                </p>
                <p className="text-gray-600 mb-1">
                  <span className="font-medium">Phone:</span> {favContractor.phoneNumber}
                </p>
                <p className="text-gray-600 mb-1">
                  <span className="font-medium">Added:</span> {new Date(favContractor.dateAdded).toLocaleDateString()}
                </p>
              </Link>
              <div className="mt-4">
                <FavoriteButton
                  contractorId={favContractor.contractorProfileId}
                  initialIsFavorited={true} // Always true on this page
                  onToggleFavorite={handleToggleFavorite}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserFavoriteContractorsPage;